import { ListItemIcon, MenuItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import React, { useContext } from "react";
import { authInfoContext } from "../context/GlobalState";

export default function LoginDialog() {
  const [open, setOpen] = React.useState(false);
  const context = useContext(authInfoContext);
  const { authInfo } = context;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogin = () => {
    context.login("token");
    handleClose();
  };

  const handleLogout = () => {
    context.logout();
  };

  function LoginAndOut() {
    if (authInfo.loggedIn) {
      return (
        <MenuItem
          onClick={() => {
            handleLogout();
          }}
        >
          <ListItemIcon>
            <PowerSettingsNewIcon />
          </ListItemIcon>
          登出
        </MenuItem>
      );
    }
    return (
      <MenuItem
        onClick={() => {
          handleClickOpen();
        }}
      >
        <ListItemIcon>
          <FingerprintIcon />
        </ListItemIcon>
        登录
      </MenuItem>
    );
  }

  return (
    <div>
      <LoginAndOut />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>登录</DialogTitle>
        <DialogContent>
          <DialogContentText>用户名密码与校园网账号相同</DialogContentText>
          <TextField
            // autoFocus
            margin="dense"
            id="account"
            label="账号"
            type="text"
            fullWidth
          />
          <TextField
            margin="dense"
            id="pswd"
            label="密码"
            type="password"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            取消
          </Button>
          <Button onClick={handleLogin} color="primary">
            登录
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
